/**
 * @generated SignedSource<<904f52195a715fd5575c0c98f26b59b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompanyLists_organization$data = {
  readonly id: string;
  readonly visitorIsMember: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"OverviewUserListsSectionEmptyState_organization">;
  readonly " $fragmentType": "CompanyLists_organization";
};
export type CompanyLists_organization$key = {
  readonly " $data"?: CompanyLists_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompanyLists_organization">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompanyLists_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorIsMember",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OverviewUserListsSectionEmptyState_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "54d4f854a291181e3e3a9b85f31576ee";

export default node;
